import { functions } from "Services/firebase";
export const createParentAccount = functions.httpsCallable(
  "createAccounts-createParentAccount"
);
export const createKidsAccount = functions.httpsCallable(
  "createAccounts-createKidsAccount"
);
